import { Outlet } from "react-router"

export function Component() {
  return <Outlet />
}
